import React, {Component} from 'react';

import styles from "./ReportStatistici.module.css";
import Table from "../../components/table/Table";
import OggettiUtili from "../../utils/OggettiUtili";
import Utils from '../../utils/Utils';
import {withTranslation} from "react-i18next";
import SegnalazioniServices from "../../services/SegnalazioniServices";
import toasterConfig from "../../config/toasterConfig";
import Spinner from "../../components/spinner/Spinner";
import ToasterSingleton from "../../singleton/ToasterSingleton";
import Select from "../../components/select/Select";
import CheckBox from "../../components/checkbox/CheckBox";
import Icon from "../../components/icon/Icon";
import TooltipIcon from "../../components/tooltip/Tooltip"
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import $ from 'jquery';
import Modale from "../../components/modale/Modale";
import {StepRicerca} from "./stepRicerca/StepRicerca";

class ReportStatistici extends Component {

    state = {
        rowsTable: [],
        cols: [],
        totalElements: 0,
        page: 0,
        totalPages: 0,
        size: 10,
        loading: false,
        filtri: {},
        malattie: JSON.parse(sessionStorage.getItem("malattie")),
        malattiePerDescrizione: JSON.parse(sessionStorage.getItem("malattiePerDescrizione")),
        sendRequest: false,
        report: {},
        intervalliClasseEta: 0,
        check: {
            sesso: true,
            rapporto: false,
            mediaRegionale: true
        },
        renderBox: "",
        viewGraph: false,
        renderBoxGraph: "",
        paginaReport: OggettiUtili.StepReport.CRITERI_SELEZIONE.codice
    }


    rows =
        {
            tipoData: {
                id1: "dataButton1",
                id2: "dataButton2",
                name: "tipoData",
                text1: "Data inizio sintomi",
                text2: "Data di segnalazione",
                field1: "dataButton1",
                field2: "dataButton2"
            },
            data: {
                id: "dataDa",
                id1: "dataA",
                radioNav: "si",
                text: "Data di inizio sintomi",
                text1: "Data di segnalazione",
                field: "dataDa",
                fieldRadio: "dataA",
                placeholder: "segnalazione da",
                placeholder1: "segnalazione a"
            },
            ulssNotifica: {
                id: "ulssNotifica",
                field: "ulssNotifica",
                text: "ULSS di notifica"
            },
            ulssAssistenza: {
                id: "ulssAssistenza",
                field: "ulssAssistenza",
                text: "ULSS di residenza"
            },
            checkStato: {
                id1: "segnalazione",
                id2: "possibile",
                id3: "probabile",
                id4: "confermato",
                field1: "segnalazione",
                field2: "possibile",
                field3: "probabile",
                field4: "confermato",
                text1: "segnalazione",
                text2: "possibile",
                text3: "probabile",
                text4: "confermato"
            },
            malattia: {
                id: "malattia",
                text: "malattia",
                field: "malattia",
                suggestions: this.state.malattie,
                keyField: "codice",
                descriptionField: "codDesc",
                suggestionField: "descrizione",
                disabled: true
            },
        }

    constructor(props) {
        super(props);

        this.setStateGenerico = this.setStateGenerico.bind(this)
        this.riceviValoreIntervalloEta = this.riceviValoreIntervalloEta.bind(this)
        this.riceviValore = this.riceviValore.bind(this);
        this.renderTable = this.renderTable.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this)
        this.changePageTable = this.changePageTable.bind(this);
        this.changePaginationTable = this.changePaginationTable.bind(this);
        this.createObjectBE = this.createObjectBE.bind(this)
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.buildParamsJson = this.buildParamsJson.bind(this);
        this.buildParamsQueryString = this.buildParamsQueryString.bind(this);
        this.downloadXls = this.downloadXls.bind(this)
        this.downloadPdf = this.downloadPdf.bind(this)

    }

    componentWillUnmount() {
        this.props.creaStepProgressReport({stepProgressReport: false})
        ToasterSingleton.instance().cancellazioneSottoscrizione()
    }

    setStateGenerico(object) {
        this.setState(object)
    }

    componentDidMount() {

        ToasterSingleton.instance().sottoscrizione(this)
        let object = {
            stato: this.state.filtri,
            setStatePadre: this.setStateGenerico,
            rows: this.rows,
            applicaFiltri: (click) => {
                this.state.filtri && this.state.filtri.malattia && this.state.filtri.malattia.length > 0 ? this.sendRequest(this.buildParamsQueryString(), this.buildParams(this.state.filtri, true, false), click) : this.aggiungiToaster(toasterConfig.types.confirm, ["Messages.ErrorInsertMalattia"])
            }
        }
        this.props.creaFiltri({filtri: object})
        this.props.creaStepProgressReport({stepProgressReport: true})

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.cols != this.state.cols) {
            this.renderTable()
        }

        if (prevState.renderBoxGraph !== this.state.renderBoxGraph) {
            window.scrollTo(0, document.body.scrollHeight);
        }

    }

    showTooltip = () => $('#tooltipMediaRegionale').css('opacity', '1');
    hideTooltip = () => $('#tooltipMediaRegionale').css('opacity', '0');

    buildParams(andParams, sendRequest, downloadReport) {

        this.setState({oldFiltri: JSON.parse(JSON.stringify(this.state.filtri)), viewGraph: false})

        let state = this.state

        if(!downloadReport) {

            state["check"].sesso = true
            state["check"].rapporto = false
            state["check"].mediaRegionale = true
            state["intervalliClasseEta"] = 0
            state.page = 0
        }

        let params = this.state.filtri
        if(!downloadReport) {
            params["dataDa"] = Utils.transformDateForBackend(params["dataDa"])
            params["dataA"] = Utils.transformDateForBackend(params["dataA"])
            params["mediaRegionale"] = this.state.check.mediaRegionale
            params["rapporto"] = this.state.check.rapporto
            params["sesso"] = this.state.check.sesso
            params["intervalliClasseEta"] = undefined
        }
        let object = JSON.parse(JSON.stringify(params))

        if(!downloadReport) this.setState({sendRequest: sendRequest})

        return Utils.removeEmptyValueFromObject(object);

    }


    buildParamsQueryString(page, size, sort, direction) {
        let pagination = {}

        if (sort) pagination.sort = sort[sort.length - 1] === "F" ? sort.substring(0, sort.length - 1).concat(".").concat("femmine") : sort[sort.length - 1] === "M" ? sort.substring(0, sort.length - 1).concat(".").concat("maschi") : sort === "maschiTot" ? "maschi" : sort === "femmineTot" ? "femmine" : sort
        if (pagination.sort === "2mesi-2anni.femmine" || pagination.sort === "2mesi-2anni.maschi" || pagination.sort === "2mesi-2anni") {
            pagination.sort = pagination.sort.replace("2mesi-2anni", "2-2")
        }
        if (pagination.sort) {
            switch (pagination.sort.substring(0, 3)) {
                case "≥65":
                    pagination.sort = pagination.sort.substring(3) === ".femmine" ? "65.femmine" : pagination.sort.substring(3) === ".maschi" ? "65.maschi" : "65";
                    break;
                case "≥91":
                    pagination.sort = pagination.sort.substring(3) === ".femmine" ? "91.femmine" : pagination.sort.substring(3) === ".maschi" ? "91.maschi" : "91";
                    break;

                default:
                    break;
            }
        }

        pagination["page"] = page
        pagination["size"] = size
        pagination["order"] = direction
        return pagination;
    }

    buildParamsJson() {
        let params = this.state.filtri
        params["dataDa"] = Utils.transformDateForBackend(params["dataDa"])
        params["dataA"] = Utils.transformDateForBackend(params["dataA"])
        params["sesso"] = this.state.check.sesso
        params["rapporto"] = this.state.check.rapporto
        params["mediaRegionale"] = this.state.check.mediaRegionale
        if (this.state.intervalliClasseEta !== 0)
            params["intervalliClasseEta"] = this.state.intervalliClasseEta
        return params;
    }


    buildExelPdf(formato) {
        let params = {}
        let filtri = JSON.parse(JSON.stringify(this.state.filtri))

        filtri["ulssNotificaDescrizioni"] = Utils.getDescrizioniUlss(filtri["ulssNotifica"])
        filtri["ulssAssistenzaDescrizioni"] = Utils.getDescrizioniUlss(filtri["ulssAssistenza"])

        params["filtri"] = filtri;
        params["rapporto"] = this.state.check.rapporto;
        params["intervallo"] = this.state.intervalliClasseEta;
        params["formato"] = formato

        return Utils.removeEmptyValueFromObject(params)
    }

    sendRequest(pagination, params) {

        if (pagination.size)
            this.setState({loading: true, size: params.size});
        else
            this.setState({loading: true});
        if (pagination.page === null || pagination.page === undefined)
            pagination.page = this.state.page;

        if(params && params.intervalliClasseEta === "0"){
            delete params.intervalliClasseEta
        }
        SegnalazioniServices.getReportStatistici(pagination, params)
            .then((data) => {

                let res = SegnalazioniServices.mapGetSegnalazioniReport(data, this.state.intervalliClasseEta, this.state.check.rapporto)
                let cols = SegnalazioniServices.mapColsSegnalazioniReport(res[0], this.state.check.mediaRegionale, this.state.check.sesso, pagination.order, pagination.sort, this.state.check.rapporto)

                this.setState({
                    cols: cols, rowsTable: res, totalElements: data.data.totalElements,
                    totalPages: data.data.totalPages, page: pagination.page,
                    loading: false
                });
                this.renderTable(cols, this.state.rowsTable)
            })
            .catch(() => {
                console.log("[Error] GetSegnalazioni in errore ");

                let cols = [
                    {key: "malattia", name: "Malattia", sortDirection: "none"},
                    {key: "femmine", name: "Femmine Tot", sortDirection: "none"},
                    {key: "maschi", name: "Maschi Tot", sortDirection: "none"},
                    {key: "totale", name: "Totale", sortDirection: "none"},
                    {key: "mediaRegionale", name: "Media Regionale"},
                ]
                this.setState({rowsTable: [], totalElements: 0, loading: false})
                this.renderTable(cols, this.state.rowsTable)
            });

        this.setState({click: true, paginaReport: OggettiUtili.StepReport.REPORT.codice})
    }

    changePageTable(sort, direction, page, size) {
        let params = {}
        params = this.buildParamsJson();
        let pagination = this.buildParamsQueryString(page, size, sort, direction)
        if (size != null) {
            if (size !== this.state.size) {
                pagination.size = this.state.size
            } else {
                pagination.size = size
            }
        }

        this.sendRequest(pagination, params);
    }

    customizeTick = (props) => {
        const {x, y, payload} = props;
        return (
            <text x={x - 60} y={y + 15} textAnchor="start" fill="#666">
                {Utils.DaysToDate(payload.value)}
            </text>
        );
    };

    handleLinkClick(row) {
        let codiceMalattia = this.state.malattiePerDescrizione[row.malattia].codice
        let params = {}
        params["malattia"] = codiceMalattia
        if (this.state.oldFiltri) {
            if (this.state.oldFiltri.dataDa) params["dataDa"] = Utils.transformDateForBackend(this.state.oldFiltri.dataDa)
            if (this.state.oldFiltri.dataA) params["dataA"] = Utils.transformDateForBackend(this.state.oldFiltri.dataA)
            params["tipoData"] = this.state.oldFiltri.tipoData
        }
        SegnalazioniServices.getGraficoReportStatistici(params)
            .then((data) => {
                if (data.data.length > 0) {
                    let newData = data.data

                    if (this.state.oldFiltri && this.state.oldFiltri.dataDa && Utils.DateToDays(this.state.oldFiltri.dataDa) < Utils.DateToDays(newData[0].date)) {
                        let obj = {
                            date: Utils.trasformData(this.state.oldFiltri.dataDa),
                            mediaRegionale: row.mediaRegionale,
                            amount: 0
                        }

                        newData.splice(0, 0, obj);
                    }

                    for (let i in newData) {
                        newData[i].date = Utils.DateToDays(Utils.transformDateForFrontend(newData[i].date))
                        newData[i].mediaRegionale = row.mediaRegionale
                    }

                    let renderBoxGraph = (
                        <div style={{width: '100%', height: 400}}>
                            <ResponsiveContainer className="bank-transactions-chart-container" width="95%">
                                <LineChart className="bank-transactions-chart" data={newData}>
                                    <XAxis
                                        dataKey="date"
                                        type={"number"}
                                        domain={[this.state.oldFiltri && this.state.oldFiltri.dataDa ? Utils.DateToDays(Utils.trasformData(Utils.transformDateForFrontend(this.state.oldFiltri.dataDa))) : 'dataMin', 'dataMax']}
                                        tick={(props) => this.customizeTick(props)}
                                        tickCount={11}
                                    />
                                    <YAxis/>
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <Tooltip labelFormatter={item => Utils.DaysToDate(item)}/>
                                    <Legend height={36}/>
                                    <Line type="monotone" dataKey="amount" stroke="#2ac940" name={row.malattia}/>
                                    <Line type={this.state.check.mediaRegionale ? "monotone" : ""}
                                          dataKey={this.state.check.mediaRegionale ? "mediaRegionale" : ""}
                                          stroke={this.state.check.mediaRegionale ? "#fbab40" : ""}
                                          name={this.state.check.mediaRegionale ? "Media regionale" : ""}/>
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    );

                    this.setState({viewGraph: true, renderBoxGraph: renderBoxGraph})

                }
            })
            .catch(() => {
                console.log("[Error] GetGraficoReportStatistici in errore ");
            });
    }


    changePaginationTable(sort, direction, page, size) {
        let params = this.buildParamsJson();
        let pagination = this.buildParamsQueryString(page, size, sort, direction)
        if (size != null)
            params.size = size
        this.sendRequest(pagination, params);
    }


    aggiungiToaster(type, text) {

        ToasterSingleton.instance().aggiuntaToaster({
            type: type,
            text: text,
            timestamp: Date.now()

        })
        this.setState({click: false, viewGraph: false, paginaReport: OggettiUtili.StepReport.CRITERI_SELEZIONE.codice})
    }


    riceviValoreIntervalloEta(event) {
        let stato = this.state

        if (event.target.value == 0) stato.check.rapporto = false
        stato.intervalliClasseEta = event.target.value

        this.setState({
            state: stato,
            viewGraph: false
        });

        this.createObjectBE(event.target.id, event.target.value)
    }

    createObjectBE(field, value) {

        let jsonInsert = this.state.oldFiltri;

        if (jsonInsert.dataDa) jsonInsert["dataDa"] = Utils.transformDateForBackend(jsonInsert.dataDa)
        if (jsonInsert.dataA) jsonInsert["dataA"] = Utils.transformDateForBackend(jsonInsert.dataA)

        jsonInsert.intervalliClasseEta = field === "intervalliClasseEta" ? value : this.state.intervalliClasseEta
        jsonInsert.sesso = field === "sesso" ? value : this.state.check.sesso
        jsonInsert.rapporto = field === "rapporto" ? value : this.state.check.rapporto
        jsonInsert.mediaRegionale = field === "mediaRegionale" ? value : this.state.check.mediaRegionale
        if (jsonInsert.intervalliClasseEta === 0) delete jsonInsert.intervalliClasseEta
        this.sendRequest({}, JSON.parse(JSON.stringify(jsonInsert)))
    }

    riceviValore(field, event) {

        let check = this.state.check
        check[field] = event.target.value
        if (check[field] === "false") {
            check[field] = false
        } else if (check[field] === "true") {
            check[field] = true
        }
        if (field === "rapporto") {
            check["sesso"] = true
        }
        this.setState({
            check: check,
            viewGraph: false
        });

        this.createObjectBE(event.target.id, event.target.value === "true" ? true : false)

    }

    renderTable(cols, rows) {
        const t = this.props
        let renderBox =
            <Table
                id={"reportTable"}
                cols={cols}
                rows={rows}
                empty={this.state.rowsTable && this.state.rowsTable.length == 0}
                onSelectCheckbox={this.selectRow}
                emptyMsg={"Non sono presenti segnalazioni"}
                lengthEditable={true}
                bigTable={true}
                homePage={true}
                reportStatistici={true}
                totalElements={this.state.totalElements}
                totalPages={this.state.totalPages}
                page={this.state.page}
                changePage={this.changePageTable}
                changePagination={this.changePaginationTable}
                onButtonSelect={this.handleLinkClick}
                rapporto={this.state.check.rapporto}
            />
        ;

        this.setState({renderBox: renderBox})

    }

    downloadXls() {
        this.setState({loading: true});
        let request = this.buildExelPdf("xlsx")

        if(request.intervallo != null && request.intervallo.toString() === "0"){
            request.filtri.intervalliClasseEta = null;
        }
        else{
            request.filtri.intervalliClasseEta =  request.intervallo
        }

        request.filtri.rapporto = this.state.check.rapporto
        request.filtri.mediaRegionale = this.state.check.mediaRegionale
        request.filtri.sesso = this.state.check.sesso

        let json = this.buildParams(this.state.filtri, true, true);

        json.intervalliClasseEta = request && request.intervallo != null && request.intervallo.toString() === "0" ? null : request.intervallo

        json.rapporto = request && request.rapporto ? request.rapporto : this.state.check.rapporto

        let pagination = this.buildParamsQueryString();
        pagination.size = this.state.totalElements;
        pagination.page = 0;

        SegnalazioniServices.getReportStatistici(pagination, json)
            .then((data) => {

                let res = SegnalazioniServices.mapGetSegnalazioniReport(data, json.intervalliClasseEta, json.rapporto)

                request.report = res
                SegnalazioniServices.getReportStatisticiExcelPdf(request).then(data => {
                    Utils.downloadReport(data.data.stream, data.data.descrizione, data.data.formato)
                    this.setState({loading: false});
                })

            })
            .catch(() => {
                console.log("[Error] GetSegnalazioni in errore ");
            });
    }

    downloadPdf() {
        this.setState({loading: true});
        let request = this.buildExelPdf("pdf")

        if(request.intervallo != null && request.intervallo.toString() === "0"){
            request.filtri.intervalliClasseEta = null;
        }
        else{
            request.filtri.intervalliClasseEta =  request.intervallo
        }

        request.filtri.rapporto = this.state.check.rapporto
        request.filtri.mediaRegionale = this.state.check.mediaRegionale
        request.filtri.sesso = this.state.check.sesso

        let json = this.buildParams(this.state.filtri, true, true);

        json.intervalliClasseEta = request && request.intervallo != null && request.intervallo.toString() === "0" ? null : request.intervallo

        json.rapporto = request && request.rapporto ? request.rapporto : this.state.check.rapporto

        let pagination = this.buildParamsQueryString();
        pagination.size = this.state.totalElements;
        pagination.page = 0;

        SegnalazioniServices.getReportStatistici(pagination, json)
            .then((data) => {

                let res = SegnalazioniServices.mapGetSegnalazioniReport(data, json.intervalliClasseEta, json.rapporto)

                request.report = res
                 SegnalazioniServices.getReportStatisticiExcelPdf(request).then(data => {
                    Utils.downloadReport(data.data.stream, data.data.descrizione, data.data.formato)
                    this.setState({loading: false});
                })

            })
            .catch(() => {
                console.log("[Error] GetSegnalazioni in errore ");
            });
    }

    render() {

        const {t} = this.props;

        const filtriTabella = (
            <div className={"container"}>
                <p><b>Parametri di analisi:</b></p>
                <Select
                    id={"intervalliClasseEta"}
                    value={this.state.intervalliClasseEta}
                    onChange={this.riceviValoreIntervalloEta}
                    vaccinazione={true}
                    functionMap={Utils.mapToArray(OggettiUtili.IntervalloEta).map((oggetto) => {
                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                    })}>

                </Select>
                <div className={"row"}>
                    <div className={"col-lg-8"}>
                        <fieldset disabled={this.state.check.rapporto}>
                            <CheckBox id={"sesso"}
                                      checked={this.state.check.sesso}
                                      text={"Sesso"}
                                      onChange={this.riceviValore}
                                      newCheckbox={true}
                                      fontColor={"#1b7ea9"}
                                      fontSize={"15px"}
                            >
                            </CheckBox>
                        </fieldset>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <fieldset disabled={this.state.intervalliClasseEta == 0}>
                            <CheckBox id={"rapporto"}
                                      checked={this.state.check.rapporto}
                                      text={"Rapporto sesso/classe di età"}
                                      onChange={this.riceviValore}
                                      newCheckbox={true}
                                      fontColor={"#1b7ea9"}
                                      fontSize={"15px"}
                            >
                            </CheckBox>
                        </fieldset>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-lg-8"}>
                        <CheckBox id={"mediaRegionale"}
                                  checked={this.state.check.mediaRegionale}
                                  text={"Media regionale"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                                  fontColor={"#1b7ea9"}
                                  fontSize={"15px"}
                        >
                        </CheckBox>
                    </div>

                    <div className={"col-lg-2"}>
                        <div className={"mt-2"}>
                            <Icon onMouseOver={this.showTooltip} onMouseOut={this.hideTooltip}
                                  style={{fill: "#1b7ea9", width: "20px"}} id={"it-info-circle"}></Icon>
                            <TooltipIcon id={"tooltipMediaRegionale"} text={["La ", <b>media
                                regionale</b>, " è calcolata come la somma delle segnalazioni per ciascuna ULSS (segnalazioni totali)," +
                            " in un dato intervallo temporale, diviso il numero delle ULSS."]}></TooltipIcon>
                        </div>
                    </div>

                </div>

            </div>
        );

        const tableDiv = (
            <div className="container mt-3">
                <div className={styles.contenitoreTabella} style={{marginTop: "2px"}}>
                    {this.state.renderBox}
                </div>
            </div>
        );

        const form = (
            <div style={{paddingTop: "2rem"}}>
                <div className={"row"}>
                    <div className={"col-lg-2"}>
                        <fieldset disabled={this.state.rowsTable.length === 0}>
                            {filtriTabella}
                        </fieldset>
                    </div>
                    <div className={"col-lg-10"}>
                        {tableDiv}
                    </div>
                    <div className={"col-lg-12"}>
                        {this.state.viewGraph ? this.state.renderBoxGraph : <></>}
                    </div>
                </div>
            </div>
        );

        const exelPdf = (
            <div>
                <Modale className={styles.testo}
                        id="modaleDownloadExcel"
                        name="modaleDownloadExcel"
                        modalText={this.state.totalElements > 5000 ? "Si vuole procedere con il download di " + this.state.totalElements + " elementi riportati in tabella? L’operazione potrebbe richiedere fino ad un minuto. Si consiglia di applicare uno o più filtri per diminuire il tempo di elaborazione." : "Si vuole procedere con il download di " + this.state.totalElements + " malattie? "}
                        text={<Icon style={{paddingRight: "10px", fill: "#00d700"}} id="it-file"/>}
                        typeModal="modalConsenso"
                        textButtonOk={"Prosegui"}
                        textButtonKo={"Annulla"}
                        classes="btn mt-2 btnWhite mb-1 "
                        style={{padding: "5px", border: "none", background: "none", float: "right", width: "30px"}}
                        title={"Scarica in formato Excel"}
                        confirmFun={this.downloadXls}
                        disabled={this.state.totalElements === 0 && this.state.rowsTable.length === 0}
                />
                <Modale title={"Scarica in formato Pdf"}
                        className={styles.testo}
                        id="modaleDownload"
                        name="modaleDownload"
                        modalText={this.state.totalElements > 5000 ? "Si vuole procedere con il download di " + this.state.totalElements + " elementi riportati in tabella? L’operazione potrebbe richiedere fino ad un minuto. Si consiglia di applicare uno o più filtri per diminuire il tempo di elaborazione." : "Si vuole procedere con il download di " + this.state.totalElements + " malattie? "}
                        text={<Icon style={{paddingRight: "10px", fill: "#ff0000"}} id="it-file"/>}
                        typeModal="modalConsenso"
                        textButtonOk={"Prosegui"}
                        textButtonKo={"Annulla"}
                        classes="btn mt-2 btnWhite mb-1 "
                        style={{padding: "5px", border: "none", background: "none", float: "right", width: "30px"}}
                        confirmFun={this.downloadPdf}
                        disabled={this.state.totalElements === 0 && this.state.rowsTable.length === 0}/>
            </div>
        );

        const spinnerDiv = (
            <div>
                <Spinner/>
            </div>
        );

        return (
            <div>
                {ToasterSingleton.instance().renderToaster()}
                <div style={{marginLeft: "25px"}}><StepRicerca pagina={this.state.paginaReport}></StepRicerca>
                    <div style={{marginTop: "25px"}}></div>
                </div>
                {this.state.click ?
                    <div>
                        {exelPdf}
                        {form}
                        {this.state.loading ?
                            (<div>{spinnerDiv}</div>) : (<div/>)} </div> : null
                }
            </div>
        );
    }
}

export default withTranslation('common')(ReportStatistici)
